import { useTranslation } from 'react-i18next';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Loading } from '@shape-ds/components';
import './style.scss';

interface Props {
  className?: string;
  i18nKey: string;
  icon?: React.ReactNode | null;
  isLoading?: boolean;
}
export const NoData = ({
  className = '',
  icon = <HighlightOffIcon />,
  i18nKey,
  isLoading = false,
}: Props) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <Loading center />;
  }

  return (
    <div className={`case-no-data-available ${className}`} data-testid="no-data-component">
      <div className="icon" data-testid="icon">
        {icon}
      </div>
      <span className="message">{t(i18nKey)}</span>
    </div>
  );
};
